// import React,{Component} from "react";

// // reactstrap components
// import {
//   Col,
//   Label
// } from "reactstrap";
// import { Checkbox } from '@mui/material';

// import "components/custom.css";

// class MultipleAnswer extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       question:"",
//       secondCount:1200,
//       questionId:"",
//       reset:false,
//       is_answer:false,
//       selectedValue:[],
//       correctFlag:true,
//       resultObj:{}
//     };
//   }
//   componentDidMount() {

//   }
//   arr = [];
//   removeItem = (array, item) => {
//     for(var i in array){
//         if(array[i]==item){
//             array.splice(i,1);
//             break;
//         }
//     }
// }

// stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
// }

//   handleChange = (event) => {
//     this.props.showResult();
//     let correct = this.props.data.option.filter(function (item) {
//   return item.correct == 1;
// }).map(function (i) {
//   return i.id;
// })
//     let arr = this.state.selectedValue;
//     let val = event.target.value;
//     arr.includes(parseInt(val))?this.removeItem(arr, parseInt(val)):arr.push(parseInt(val))
//     this.props.submit({'answer':arr,'correct':correct},true);
//     this.setState({selectedValue:arr,resultObj:{'answer':arr,'correct':correct} });
//   };

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);
//   			return {secondCount:1200,questionId: props.data.id,reset:true,correctFlag:true};
//   		}else{
//   			if (!state.questionId) {
//   				return {questionId: props.data.id,correctFlag:true};
//   			}
//   		}
  		
//   		}    
//   }

// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);
// 		}
// 		this.setState({ secondCount: this.state.secondCount -1 });
// 	}

//   showAnswer = () => {
//     if (this.props.answer != this.state.is_answer) {
//       this.setState({is_answer:true});  
//     }
//   }

//   updateCorrect = () =>{
//     let correct = this.props.data.option.filter(function (item) {
//         return item.correct == 1;
//       }).map(function (i) {
//         return i.id;
//       });
    
//      this.props.submit({'correct':correct,answer:[]});
//      this.setState({correctFlag:false,resultObj:{'correct':correct,answer:[]}})
//   } 

// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}

//  // this.setState(state => {
//  //     const list = state.list.push(state.value);
//  //     return {
//  //       list,
//  //       value: '',
//  //     };
//  //   });

  
//   render() {
//   	let question ="";
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       if (this.state.correctFlag) {
//         this.updateCorrect();  
//       }      
//   	}
//     if (this.props.restart) {
//       this.props.restartQue();
//     }

//     if (this.props.stopRecording) {
//       this.stopTest();      
//     }

//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false,is_answer:false,selectedValue:[]});
//   	}
//     return (
//       <>
//       <div className="container-fluid">
//         <div className="row">
//           <Col xs={6}><h5>{question}</h5></Col>
//           <Col xs={6}>
//           <div>
//             <h4 className="infoText"></h4>
//           </div>
//           <h3 className="question">{this.props.data && this.props.data.question_mcq}</h3>
//           <div className="answers">
//           {this.props.data && this.props.resultMode && this.props.data.option.map(function(item){
//                   return <React.Fragment>
//                           <Label className={ this.props.answer && item.correct === 1 && 'correct-line' }>
//                             <Checkbox
//                                 checked={this.state.selectedValue.includes(item.id)}
//                                 value={item.id}
//                                 color="default"
//                                 onChange={this.handleChange}
//                                 inputProps={{ 'aria-label': 'secondary checkbox' }}
//                                 name="answer"
//                               />{' '}
//                             {item.options}
//                           </Label>
//                         </React.Fragment>;
//                 },this) }
//                 {this.props.data && !this.props.resultMode && this.props.data.option.map(function(item){
//                   return <React.Fragment>
//                           <Label className={ this.props.answer && (item.correct === 1?(this.state.selectedValue.includes(item.id)?'correct-line':'blue-line'):(this.state.selectedValue.includes(item.id))?'red-line':'') }>
//                             <Checkbox
//                                 checked={this.state.selectedValue.includes(item.id)}
//                                 value={item.id}
//                                 color="default"
//                                 onChange={this.handleChange}
//                                 inputProps={{ 'aria-label': 'secondary checkbox' }}
//                                 name="answer"
//                               />{' '}
//                             {item.options}
//                           </Label>
//                         </React.Fragment>;
//                 },this) }
//           </div>
//           </Col>
//         </div>
//       </div>
//       </>
//     );
//   }
// }
// export default MultipleAnswer;


// import React, { useState, useEffect, useRef } from "react";
// import {Col , Form} from "react-bootstrap";
// import { Checkbox } from '@mui/material';

// import "components/custom.css";

// const MultipleAnswer = (props) => {
//   const [question, setQuestion] = useState("");
//   const [secondCount, setSecondCount] = useState(1200);
//   const [questionId, setQuestionId] = useState("");
//   const [reset, setReset] = useState(false);
//   const [is_answer, setIsAnswer] = useState(false);
//   const [selectedValue, setSelectedValue] = useState([]);
//   const [correctFlag, setCorrectFlag] = useState(true);
//   const [resultObj, setResultObj] = useState({});
//   const [intervalId, setIntervalId] = useState(null);
//   const [questionText, setQuestionText] = useState("");
//   const prevQuestionIdRef = useRef(null);
//   const restartHandledRef = useRef(false);
//   const intervalRef = useRef(null);
//   // const arr = useRef([]);

//   const removeItem = (array, item) => {
//     for(var i in array){
//         if(array[i]==item){
//             array.splice(i,1);
//             break;
//         }
//     }
//   };

//   const stopTest = () => {
//     props.nextQuestion(resultObj);
//   };

//   const handleChange = (event) => {
//     props.showResult();
//     let correct = props.data.option.filter(function (item) {
//       return item.correct == 1;
//     }).map(function (i) {
//       return i.id;
//     });
    
//     let arr = [...selectedValue];
//     let val = event.target.value;
//     arr.includes(parseInt(val)) ? removeItem(arr, parseInt(val)) : arr.push(parseInt(val));
//     props.submit({'answer':arr,'correct':correct}, true);
//     setSelectedValue(arr);
//     setResultObj({'answer':arr,'correct':correct});
//   };

//   // const timer = () => {
//   //   setSecondCount(prevCount => {
//   //     if (prevCount === 1) {
//   //       clearInterval(intervalId);
//   //     }
//   //     return prevCount - 1;
//   //   });
//   // };

//   // const showAnswer = () => {
//   //   if (props.answer != is_answer) {
//   //     setIsAnswer(true);  
//   //   }
//   // };

//   const timer = () => {
//     setSecondCount((prev) => {
//       if (prev <= 1) {
//         clearInterval(intervalRef.current);
//         intervalRef.current = null;
//         return 0;
//       }
//       return prev - 1;
//     });
//   };

//   useEffect(() => {
//     // Prevent multiple intervals
//     if (intervalRef.current) return;

//     intervalRef.current = setInterval(timer, 1000);

//     return () => {
//       clearInterval(intervalRef.current);
//       intervalRef.current = null;
//     };
//   }, []);

//   const updateCorrect = () => {
//     let correct = props.data.option.filter(function (item) {
//         return item.correct == 1;
//       }).map(function (i) {
//         return i.id;
//       });
    
//     props.submit({'correct':correct, answer:[]});
//     setCorrectFlag(false);
//     setResultObj({'correct':correct, answer:[]});
//   };

//   // Handle getDerivedStateFromProps logic
//   // useEffect(() => {
//   //   console.log(props);

//   //   if (props.data) {
//   //     setQuestionText(props.data.question);
//   //     if ((questionId && questionId !== props.data.id) || props.restart) {
//   //       clearInterval(intervalId);
//   //       setSecondCount(1200);
//   //       setQuestionId(props.data.id);
//   //       setReset(true);
//   //       setCorrectFlag(true);
//   //     } else {
//   //       if (!questionId) {
//   //         setQuestionId(props.data.id);
//   //         setCorrectFlag(true);
//   //       }
//   //     }
//   //      if (props.restart) {
//   //       props.restartQue();
//   //     }
//   //   }
//   // }, [props.data, props.restart]);

//   useEffect(() => {
//     if (!props.data?.id) return;

//     const currentId = props.data.id;

//     // Prevent infinite loop
//     if (prevQuestionIdRef.current === currentId && !props.restart) {
//       return;
//     }

//     prevQuestionIdRef.current = currentId;

//     // Reset logic
//     setQuestionText(props.data.question);
//     clearInterval(intervalId);
//     setSecondCount(1200);
//     setQuestionId(currentId);
//     setReset(true);
//     setCorrectFlag(true);

//     // Handle restart ONCE
//     if (props.restart && !restartHandledRef.current) {
//       restartHandledRef.current = true;
//       props.restartQue();
//     }

//     // Reset restart flag when restart turns off
//     if (!props.restart) {
//       restartHandledRef.current = false;
//     }
//   }, [props.data?.id, props.data?.question, props.restart]);

//   // Handle reset logic
//   useEffect(() => {
//     if (reset) {
//       const newIntervalId = setInterval(timer, 1000);
//       setIntervalId(newIntervalId);
//       setReset(false);
//       setIsAnswer(false);
//       setSelectedValue([]);
//     }
//   }, [reset]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       clearInterval(intervalId);
//     };
//   }, [intervalId]);

//   // Render logic
//   useEffect(() => {
//     if (props.data && correctFlag) {
//       updateCorrect();
//     }
//   }, [props.data, correctFlag]);

//   // if (props.data) {
//   //   questionText = props.data.question;
//   //   console.log(questionText);     
//   // }

//   // if (props.restart) {
//   //   props.restartQue();
//   // }

//   useEffect(() => {
//        if (props.stopRecording) {
//          stopTest();
//        }
//      }, [props.stopRecording]);

//   return (
//     <>
//       <div className="container-fluid">
//         <div className="row">
//           <Col xs={6}><h5 dangerouslySetInnerHTML={{ __html: questionText }}></h5></Col>
//           <Col xs={6}>
//             <div>
//               <h4 className="infoText"></h4>
//             </div>
//             <h3 className="question">{props.data && props.data.question_mcq}</h3>
//             <div className="answers">
//               {props.data && props.resultMode && props.data.option.map(function(item){
//                 return <React.Fragment key={item.id}>
//                   <Form.Label className={props.answer && item.correct === 1 && 'correct-line'}>
//                     <span className={`${selectedValue.includes(item.id)? "selected-option": ""}`}>
//                       <Checkbox
//                         checked={selectedValue.includes(item.id)}
//                         value={item.id}
//                         // color="default"
//                         sx={{
//                             color: '#1976d2 !important',
//                             '&.Mui-checked': {
//                               color: '#1976d2 !important',
//                             },
//                         }}
//                         onChange={handleChange}
//                         inputProps={{ 'aria-label': 'secondary checkbox' }}
//                         name="answer"
//                       />{' '}
//                       {item.options}
//                     </span>
//                   </Form.Label>
//                 </React.Fragment>;
//               })}
//               {props.data && !props.resultMode && props.data.option.map((item) => {
//                 const isSelected = selectedValue.includes(item.id);
//                 return (
//                   <React.Fragment key={item.id}>
//                     <Form.Label
//                       className={`option-label`}
//                     >
//                       <span className={`${selectedValue.includes(item.id)? "selected-option": ""}`}>
//                         <Checkbox
//                           checked={isSelected}
//                           value={item.id}
//                           // color="default"
//                           sx={{
//                             color: '#1976d2 !important',
//                             '&.Mui-checked': {
//                               color: '#1976d2 !important',
//                             },
//                           }}
//                           id="multiple"
//                           className="option-checkbox"
//                           onChange={handleChange}
//                           inputProps={{ 'aria-label': 'secondary checkbox' }}
//                           name="answer"
//                         />{' '}
//                         {item.options}
//                       </span>
//                     </Form.Label>
//                   </React.Fragment>
//                 );
//               })}

//             </div>
//           </Col>
//         </div>
//       </div>
//     </>
//   );
// };

// export default MultipleAnswer;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Col, Form } from "react-bootstrap";
import { Checkbox } from '@mui/material';

import "components/custom.css";

const MultipleAnswer = (props) => {
  const [secondCount, setSecondCount] = useState(1200);
  const [selectedValue, setSelectedValue] = useState([]);
  const [questionText, setQuestionText] = useState("");
  const prevQuestionIdRef = useRef(null);
  const intervalRef = useRef(null);
  const correctSubmittedRef = useRef(false);

  // Memoized helper function
  const removeItem = useCallback((array, item) => {
    return array.filter(val => val !== item);
  }, []);

  // Extract correct answers - memoized to prevent recalculation
  const getCorrectAnswers = useCallback(() => {
    if (!props.data?.option) return [];
    return props.data.option
      .filter(item => item.correct === 1)
      .map(item => item.id);
  }, [props.data?.option]);

  // Timer function
  const timer = useCallback(() => {
    setSecondCount((prev) => {
      if (prev <= 1) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        return 0;
      }
      return prev - 1;
    });
  }, []);

  // Handle checkbox change
  const handleChange = useCallback((event) => {
    props.showResult();    
    const val = parseInt(event.target.value);
    const correct = getCorrectAnswers();
    
    setSelectedValue(prev => {
      const newArr = prev.includes(val) 
        ? removeItem(prev, val)
        : [...prev, val];
      
      // Submit immediately with new value
      props.submit({ answer: newArr, correct }, true);
      return newArr;
    });
  }, [props, getCorrectAnswers, removeItem]);

  // Stop test handler
  const stopTest = useCallback(() => {
    const correct = getCorrectAnswers();
    props.nextQuestion({ answer: selectedValue, correct });
  }, [props, selectedValue, getCorrectAnswers]);

  // Initialize timer once on mount
  useEffect(() => {
    if (intervalRef.current) return;
    
    intervalRef.current = setInterval(timer, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [timer]);

  // Handle question changes and restart
  useEffect(() => {
    if (!props.data?.id) return;

    const currentId = props.data.id;
    const questionChanged = prevQuestionIdRef.current !== currentId;

    // Only process if question changed or restart is triggered
    if (!questionChanged && !props.restart) return;

    prevQuestionIdRef.current = currentId;
    
    // Update question text
    setQuestionText(props.data.question);
    
    // Reset state for new question
    if (questionChanged) {
      setSelectedValue([]);
      setSecondCount(1200);
      correctSubmittedRef.current = false;
      
      // Restart timer
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      intervalRef.current = setInterval(timer, 1000);
    }

    // Handle restart
    if (props.restart && props.restartQue) {
      props.restartQue();
    }
  }, [props.data?.id, props.data?.question, props.restart, props.restartQue, timer]);

  // Submit correct answers once per question
  useEffect(() => {
    if (props.data?.id && !correctSubmittedRef.current) {
      const correct = getCorrectAnswers();
      props.submit({ correct, answer: [] });
      correctSubmittedRef.current = true;
    }
  }, [props.data?.id, getCorrectAnswers, props]);

  // Handle stop recording
  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording, stopTest]);

  // Render options helper
  const renderOption = useCallback((item) => {
    const isSelected = selectedValue.includes(item.id);
    const isCorrect = props.answer && item.correct === 1;
    const labelClass = props.resultMode && isCorrect ? 'correct-line' : 'option-label';
    
    return (
      <React.Fragment key={item.id}>
        <Form.Label className={labelClass}>
          <span className={isSelected ? "selected-option" : ""}>
            <Checkbox
              checked={isSelected}
              value={item.id}
              sx={{
                color: "var(--checkbox-default) !important",
                "&.Mui-checked": {
                  color: "var(--checkbox-checked) !important",
                },
              }}
              onChange={!props.resultMode && handleChange}
              inputProps={{ 'aria-label': 'secondary checkbox' }}
              name="answer"
            />{' '}
            {item.options}
          </span>
        </Form.Label>
      </React.Fragment>
    );
  }, [selectedValue, props.answer, props.resultMode, handleChange]);

  if (!props.data) return null;

  return (
    <div className="container-fluid">
      <div className="row">
        <Col xs={12} lg={props.resultMode ? 12 : 6}>
          <h5 dangerouslySetInnerHTML={{ __html: questionText }} className={props.resultMode ? "reading-text text-start":""}></h5>
        </Col>
        {!props.resultMode &&
        <Col xs={12} lg={6}>
          <div>
            <h4 className="infoText"></h4>
          </div>
          <h3 className="question mock-resource-text">{props.data.question_mcq}</h3>
          <div className="answers">
            {props.data.option?.map(renderOption)}
          </div>
        </Col>
        }
      </div>
    </div>
  );
};

export default MultipleAnswer;